var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrapper"},[_c('p',{staticClass:"text-title"},[_vm._v(_vm._s(_vm.textTitle)),_c('span',[_vm._v("…")])]),_c('p',{staticClass:"text-message"},[_vm._v(" "+_vm._s(_vm.textMessage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }